import { User } from '../UserMenu.types'

const getUserInitials = (user: User) =>
  `${(user.firstName || '').substring(0, 1)}${(user.lastName || '').substring(0, 1)}`

export default getUserInitials
